export default __webpack_public_path__ + "static/media/farmacias.687d3316.png";